export const RoutePath = {
    home: '/',
    login: '/login',
    confirm: '/confirm',
    reconfirm: '/reconfirm',
    ripeness: '/ripeness',
    dashborad: '/dashboard',
};
